<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>


                        <v-flex xs12 sm12 md12 row warp>
                            <v-flex xs3 sm3 md3 text-center  class="labelFont">
                                <v-label >主影像</v-label>
                            </v-flex>
                            <v-flex xs9 sm9 md9 pl-2>
                                <div class="d-inline-block">
                                    <img   :src="mainPict" id="image1" :class="[ mainPict!='' ? 'uerIcon' : 'noUerIcon']" ref="imgref" style=" border: 1px solid gray;min-width: 200px;
    max-width: 200px;min-height:     100px">
                                </div>
                                <div class="d-inline-block">
                                    <!-- pickPicPhoto('iptImage1','image1',25,25)-->
                                    <v-flex >
                                        <div class="pb-2">圖片建議尺寸<br>800×1200 <br> 或 長寬比 3:2
                                        </div>
                                        <input  class="custom-file-input ml-2" type="file" ref="fileref"  id="iptImage1" value="" @change="pickImage"  />

                                        <v-btn  title="刪除影像" icon  @click.native.stop="deleteImgIcon"><!---->
                                            <v-icon  color="pink">mdi-delete</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </div>
                                
                            </v-flex>
                        </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-right  class="labelFont">
                            <v-label >顯示類型</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>

                            <v-select
                                    class="mr-2"
                                    v-model="displayFlag"
                                    hide-details
                                    :items="displayFlagList"
                                    item-text="key"
                                    item-value="value"
                            ></v-select>

                            <!--<v-switch  class="mr-2"  style="float: left" hide-details  :label="`${displayFlag==true?'顯示':'隱藏'}`" v-model="displayFlag"></v-switch>-->
                        </v-flex>
                    </v-flex>


                    <v-flex row warp xs12 sm12 md12 >
                        <v-flex xs5 sm5 md3 text-center  class="labelFont">
                            <v-label >開始日期時間</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md9 pl-2 mt-3 >
                            <input style="border:1px solid black" id="startDatetime" type="datetime-local" >
                            <v-btn  title="清除日期" icon  @click.native.stop="clearDate('startDatetime')">
                                <v-icon  color="pink">mdi-delete</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-flex>



                    <v-flex row warp xs12 sm12 md12 >
                        <v-flex xs5 sm5 md3 text-center  class="labelFont">
                            <v-label >結束日期時間</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md9 pl-2 mt-3 >
                            <input style="border:1px solid black" id="endDatetime" type="datetime-local" >
                            <v-btn  title="清除日期" icon  @click.native.stop="clearDate('endDatetime')">
                                <v-icon  color="pink">mdi-delete</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-flex>



                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-right  class="labelFont">
                            <v-label >內文</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="content"  v-model="content"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-right  class="labelFont">
                            <v-label >建立者</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>
                            <v-text-field readonly :disabled="this.editIndex!==-1" v-model="createUser"   ></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-right  class="labelFont">
                            <v-label >最後修改者</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>
                            <v-text-field readonly :disabled="this.editIndex!==-1"  v-model="lastModiUser"   ></v-text-field>
                        </v-flex>
                    </v-flex>





                    <v-flex xs12 sm12 md6 d-inline-flex>
                        <v-flex xs6 sm6 md6 text-right  class="labelFont">
                            <v-label >建立日期時間</v-label>
                        </v-flex>
                        <v-flex xs6 sm6 md6 pl-2 class="labelFont">
                            {{$UtilityJs.AD2ROC_DateTime(createDatetime,'showDT')}}
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md6 d-inline-flex>
                        <v-flex xs6 sm6 md6 text-right  class="labelFont">
                            <v-label >最後修改日期時間</v-label>
                        </v-flex>
                        <v-flex xs6 sm6 md6 pl-2 class="labelFont">
                            {{$UtilityJs.AD2ROC_DateTime(lastModiDatetime,'showDT')}}
                        </v-flex>
                    </v-flex>



                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-card>
</template>

<script>
    import Vue from 'vue'
    import  MomentJs from 'vue-moment';
    Vue.use(MomentJs);
    export default {
        name: "EditNews",
        props:['editIndex','isShow','editObj'],
        data() {
            return {
                snTimeout:4000,
                snStatus:false,
                snText:'',
                startDatetime:'',//開始時間
                endDatetime:'',//結束時間
                displayFlag:true,//顯示否
                mainPict:'',//主影像
                content:'',//內文
                createDatetime:'',//建立日期
                lastModiDatetime:'',//最後修改日期
                rawPk:'',
                createUser:'',
                lastModiUser:'',
                modifyObj:{},
                displayFlagList:[
                    {key:'Y-Menu查詢',value:'Y'},
                    {key:'P-彈出視窗',value:'P'},
                    {key:'N-隱藏',value:'N'},
                ],
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.displayFlag = this.editObj.displayFlag==undefined?'':this.editObj.displayFlag;
                    this.mainPict = this.editObj.mainPict==undefined?'':this.editObj.mainPict;
                    this.content = this.editObj.content==undefined?'':this.editObj.content;
                    this.startDatetime = this.editObj.startDatetime==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.startDatetime,'showDT');
                    this.endDatetime = this.editObj.endDatetime==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.endDatetime,'showDT');
                    this.createDatetime = this.editObj.createDatetime==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.createDatetime,'all');
                    this.lastModiDatetime = this.editObj.lastModiDatetime==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.lastModiDatetime,'all');
                    this.rawPk = this.editObj.rawPk==undefined?'':this.editObj.rawPk;
                    this.startDatetime =  this.$moment(new Date(this.startDatetime)).format('YYYY-MM-DDTHH:mm')
                    this.endDatetime =  this.$moment(new Date(this.endDatetime)).format('YYYY-MM-DDTHH:mm')
                    this.lastModiUser = this.editObj.lastModiUser==undefined||this.editObj.lastModiUser==null?'':this.editObj.lastModiUser;
                    this.createUser = this.editObj.createUser==undefined||this.editObj.createUser==null?'':this.editObj.createUser;
                    // this.endDatetime =  this.$moment(this.endDatetime).format('YYYY-MM-DDTkk:mm');
                    document.getElementById("startDatetime").value = this.startDatetime;
                    document.getElementById("endDatetime").value = this.endDatetime;

                }else {
                    this.startDatetime = null;
                    this.endDatetime = null;
                    document.getElementById("startDatetime").value = '';
                    document.getElementById("endDatetime").value = '';
                    this.displayFlag = 'Y';
                    this.mainPict = '';
                    this.content = '';
                    this.createDatetime = null;
                    this.lastModiDatetime = null;
                    this.createUser = this.loginWebUser.userId;
                    this.lastModiUser = '';
                    this.rawPk = '';
                    let  img = document.getElementById('image1');
                    img.setAttribute('src', '');
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 News' : '編輯 News'
            },
            loginWebUser(){
                return this.$store.state.loginWebUser;
            },
        },
        methods:{
            clearDate(id){
                document.getElementById(id).value = null;
            },
            deleteImgIcon(){
                let  img = document.getElementById('image1');
                img.setAttribute('src', '');
            } ,
            pickImage(){
                let inputEl = document.getElementById('iptImage1');
                let imgEl = document.getElementById('image1');
                if (inputEl.files && inputEl.files[0]) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        imgEl.setAttribute('src', e.target.result);
                    };
                    reader.readAsDataURL(inputEl.files[0]);
                    inputEl.value = ''; //重置了file的value
                }
            },
            closeDialog(){
                this.$emit('closeDialog');
            },
            invalidDate(startDatetime,endDatetime){ //驗證起訖日期
                let result = '';
                let effSDate = this.$UtilityJs.AD2ROC_DateTime(startDatetime,"showDT")+":00";
                let effEDate = this.$UtilityJs.AD2ROC_DateTime(endDatetime,"showDT")+":00";
                if(startDatetime!==''&&endDatetime!==''){ //如果有輸入日期起訖範圍
                    if((Date.parse(effSDate)).valueOf() > (Date.parse(effEDate)).valueOf()){
                        result = '開始日期不能大於結束日期';
                    }else {
                        result = '';
                    }
                }else if((startDatetime==''&&endDatetime!=='')||(startDatetime!==''&&endDatetime=='')){ //如果只輸入起或迄日期
                    result = '請輸入開始和結束日期';
                }else if(startDatetime==null||endDatetime==null||startDatetime==''||endDatetime=='') {
                    result =  '請輸入開始和結束日期';
                }else {
                    result
                }
                return result;
            },
            save(){
                let img = document.getElementById('image1');
                let imgsrc = img.getAttribute('src');
                let startDatetime = document.getElementById("startDatetime").value;
                let endDatetime = document.getElementById("endDatetime").value;

                // if(startDatetime==''||endDatetime==''){
                //     alert('請輸入開始日期和結束日期')
                //     return;
                // }else {
                    let invalidDate = this.invalidDate(startDatetime,endDatetime);
                    if(invalidDate!==''){
                        alert(invalidDate)
                    }else {
                        if(this.editIndex==-1){ //新增狀態

                            this.modifyObj = {
                                rawPk:null,
                                startDatetime:startDatetime==null||startDatetime==''?null:new Date(startDatetime).toJSON(),
                                endDatetime:endDatetime==null||endDatetime==''?null:new Date(endDatetime).toJSON(),
                                mainPict : imgsrc,
                                content : this.content ,
                                displayFlag: this.displayFlag,
                                createDatetime:null,
                                lastModiDatetime:null,
                                createUser:this.createUser,
                            }
                        }else { //修改狀態
                            this.modifyObj = {
                                startDatetime:startDatetime==null||startDatetime==''?null:new Date(startDatetime).toJSON(),
                                endDatetime:endDatetime==null||endDatetime==''?null:new Date(endDatetime).toJSON(),
                                mainPict : imgsrc,
                                content : this.content ,
                                displayFlag: this.displayFlag,
                                createDatetime:null,
                                lastModiDatetime:null,
                                rawPk:this.rawPk,
                                lastModiUser:this.loginWebUser.userId,
                            }
                        }
                        this.$emit('save',this.modifyObj);
                    }
                // }






            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }

    .custom-file-input {
        color: transparent;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        height: 36px;
        /*min-height: 30px;*/
        /*max-height: 30px;*/
        vertical-align: middle;
    }
    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }
    .custom-file-input::before {
        letter-spacing: 0.1em;
        content: '+主影像';
        color: black;
        display: inline-block;
        background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
        border: 1px solid #999;
        border-radius: 15px;
        padding: 5px 8px;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        text-shadow: 1px 1px #fff;
        font-weight: 700;
        /*font-size: 10pt;*/
    }
    .custom-file-input:hover::before {
        border-color: black;
    }
    .custom-file-input:active {
        outline: 0;
    }
    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
    }




</style>